import { createReducer, on } from '@ngrx/store';
import { ContactModel } from '../../modules/shared/model/contactModel.model';
import { addContactModels, loadContactModels, removeContactModels } from '../actions/contact-model.actions';


export const contactModelFeatureKey = 'contactModel';

export interface State {
  Contact: ContactModel;
}

export const initialState: State = {
  Contact: null,
};


export const contactModelReducer = createReducer(
  initialState,
  on(loadContactModels, (state, { Contact }) => ({
    Contact})
 ),
 on(addContactModels, (state, { Contact }) => {
   return {
   ...state,
   Contact: Contact
   };
 }),
  on(removeContactModels, (state, { Contact }) => ({
    Contact: Contact
  })
  )
);
